import { DownloadRegistryEffects } from './download-registry.effects';
import { TextbooksEffects } from './textbooks.effects';
import { ShelfEffects } from './shelf.effects';

const effects = [DownloadRegistryEffects, TextbooksEffects, ShelfEffects];

export { effects, DownloadRegistryEffects, TextbooksEffects, ShelfEffects };
